import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import {
  logoutLaboTurnos,
  wsGetVerificarLaboGrupo,
  wsGetLaboTurnos,
} from "../../../context/Actions/turnos/laboTurnos";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { useHistory } from "react-router";
import { showModal, hideModal } from "../../../context/Actions/modal/modal";
import {
  editaTurnosDisponibles,
  setFechaTurno,
} from "../../../context/Actions/turnos/turnosDisponibles";
import { IonSpinner } from "@ionic/react";
import fechaTurnoFormat from "../../../../global/utils/fechaTurnoFormat";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import DatePicker from "../../Genericos/DatePicker/DatePicker";
import "./BuscadorLaboratorio.css";
import { dropdownFamiliares } from "../ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import {
  hideSegundoModal,
  showSegundoModal,
} from "../../../context/Actions/segundoModal/segundoModal";
import { GlobalContext } from "../../../../global/context/Provider";
import DropdownV2 from "_+_Portal/components/Genericos/DropdownV2/DropdownV2";
import SelectDropdown from "_+_Portal/components/Genericos/SelectDropdown/SelectDropdown";
// import { wsGetDatosPaciente } from "_+_Portal/context/Actions/paciente/paciente"; // legacy
// import { setUsuarioAuth } from "global/context/action/auth/login"; // legacy

const BuscadorLaboratorio = ({
  listaDeterminaciones,
  onChangeMultitabMobile,
  buscadorTurnos,
}) => {
  const history = useHistory();

  const {
    laboGrupoState,
    modalDispatch,
    laboTurnosDispatch,
    laboTurnosState,
    turnosDisponiblesDispatch,
    turnosDisponiblesState,
    // multiTabState, // solo se usa en código comentado
    listaFamiliaresState,
    selectDropDownState,
    // selectDropDownDispatch, // solo se usa en código comentado
    segundoModalDispatch,
    // pacienteDispatch, // solo se usa en código comentado
    labOrdenDigitalState,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { authState, /* authDispatch, */ toasterDispatch } =
    useContext(GlobalContext);

  const fechaLimte = new Date();
  const days = 90;
  fechaLimte.setDate(fechaLimte.getDate() + days);
  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;
  
  const [idGrupo, setIdGrupo] = useState("");
  const [descGrupo, setDescGrupo] = useState("");
  const [flgParticular, setFlgParticular] = useState(false);
  const [flgGrupoOk, setFlgGrupoOk] = useState(false);
  const [fecha, setFecha] = useState();
  const [flgModal, setFlgModal] = useState(false);
  const [determinaciones, setDeterminaciones] = useState(listaDeterminaciones);
  const [dtoPOST, setDtoPOST] = useState(false);
  const [filtraTurnos, setFiltraTurnos] = useState(false);
  const [deshabilitoBusq, setDeshabilitoBusq] = useState(false);
  const [OSAlternativa, setOSAlternativa] = useState(false);

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };
  const dissmissSegundoModal = () => {
    hideSegundoModal()(segundoModalDispatch);
    setOSAlternativa(false);
  };

  const onChangeDatePicker = (e) => {
    setFecha(e);
    setFechaTurno(e)(turnosDisponiblesDispatch);
  };

  // Orden postdatada: el buscador arranca con la fecha de la orden (labo usa fechaalta).
  // Solo si hay un flujo de orden activo (altaTurno). El datepicker permite elegir antes
  // → se valida al confirmar.
  useEffect(() => {
    const lod = labOrdenDigitalState?.labOrdenDigital;
    if (lod?.altaTurno && lod?.fechaOrden) {
      setFecha(lod.fechaOrden);
      setFechaTurno(lod.fechaOrden)(turnosDisponiblesDispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeBuscador = (e) => {
    if (e !== "") {
      setFlgModal(false);
      setFlgParticular(false);
      setFlgGrupoOk(false);
      if (e.id !== null && e.id !== undefined && e.id > 0) {
        setIdGrupo(e.id);
        setDescGrupo(e.descripcion);

        // Nueva lógica: verificamos directamente el grupo de laboratorio
        // sin volver a pedir los datos del paciente.
        if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
          wsGetVerificarLaboGrupo(
            e.id,
            selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
          )(laboTurnosDispatch);
        } else {
          wsGetVerificarLaboGrupo(e.id)(laboTurnosDispatch);
        }

        setDeshabilitoBusq(false);

        // Lógica anterior basada en wsGetDatosPaciente → nextStepEstudio.
        // Se deja comentada para no romper nada y poder volver atrás si hace falta.
        /*
        if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
          wsGetDatosPaciente(
            selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
            true,
            (isCorrect, data) => nextStepEstudio(isCorrect, data, e)
          )(pacienteDispatch);
        } else {
          wsGetDatosPaciente(-1, true, (isCorrect, data) =>
            nextStepEstudio(isCorrect, data, e)
          )(pacienteDispatch);
        }
        */
      }
    } else {
      setFlgModal(false);
      setFlgParticular(false);
      setFlgGrupoOk(false);
      setIdGrupo("");
      setDescGrupo("");
      setDeshabilitoBusq(true);
    }
  };

  // Función legacy: se usaba cuando se hacía wsGetDatosPaciente antes de verificar el grupo.
  // Se deja comentada para referencia, pero hoy no se invoca desde ningún flujo.
  /*
  const nextStepEstudio = (isCorrect, data, e) => {
    if (isCorrect) {
      if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
        SelectUserGlobal({ id: data.codigo, paciente: data })(
          selectDropDownDispatch
        );
        wsGetVerificarLaboGrupo(e.id, data.codigo)(laboTurnosDispatch);
      } else {
        // Si la OS se cambió procedo a armar el nuevo dto con la os nueva
        if (data?.idplan !== authState?.auth?.data?.paciente?.idplan) {
          const userDto = {
            ...authState.auth.data,
            paciente: {
              ...authState.auth.data.paciente,
              cobertura: data.cobertura,
              idplan: data.idplan,
              idplan_desc: data.idplan_desc,
              nro_afiliado: data.nro_afiliado,
              obra_social: data.obra_social,
              obra_social_desc: data.obra_social_desc,
            },
          };
          setUsuarioAuth(userDto)(authDispatch);
        }
        wsGetVerificarLaboGrupo(e.id)(laboTurnosDispatch);
      }
    } else {
      showToaster(
        {
          texto: data || "Error al obtener los datos del paciente",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };
  */

  const onBuscarTurnosClick = () => {
    if (!flgModal) {
      if (filtraTurnos) {
        if (flgGrupoOk) {
          setDtoPOST({
            fechaInvertida: fecha,
            idGrupo: idGrupo,
            OsAlternativa: OSAlternativa ? OSAlternativa : false,
          });
          if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
            wsGetLaboTurnos(
              fecha,
              -1,
              -1,
              idGrupo,
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                .id,
            )(laboTurnosDispatch);
          } else {
            wsGetLaboTurnos(fecha, -1, -1, idGrupo)(laboTurnosDispatch);
          }
          setFlgGrupoOk(false);
        }
      } else {
        showFiltrosLabo();
      }
    } else {
      if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
        wsGetVerificarLaboGrupo(
          idGrupo,
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
        )(laboTurnosDispatch);
      } else {
        wsGetVerificarLaboGrupo(idGrupo)(laboTurnosDispatch);
      }
    }
  };

  const cancelaParticular = () => {
    dissmiss();
    logoutLaboTurnos()(laboTurnosDispatch);
    setFlgParticular(false);
    setFlgModal(true);
    setFlgGrupoOk(false);
  };

  const cancelaAlternativa = () => {
    dissmiss();
    logoutLaboTurnos()(laboTurnosDispatch);
    setOSAlternativa(false);
    setFlgModal(true);
    setFlgGrupoOk(false);
  };

  const deterComoParticular = (origen) => {
    dissmiss();
    if (origen === "osAlternativa") {
      setOSAlternativa(true);
      showFiltrosLabo();
    }
    setFlgModal(false);
    setFlgGrupoOk(true);
    hideModal()(modalDispatch);
    logoutLaboTurnos()(laboTurnosDispatch);
  };

  const modalParticular = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "La obra social no cubre el estudio",
        textoNegrita: "¿Desea tomar el turno como particular?",
        texto: "El estudio seleccionado no figura dentro de tu cobertura",
        dissmiss: dissmiss,
      },
      [
        {
          text: "Cancelar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: cancelaParticular,
        },
        {
          text: "Tomar como particular",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: deterComoParticular,
        },
      ],
      "centro",
    )(modalDispatch);
  };

  const modalOSAlternativa = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "La obra social no cubre el estudio",
        textoNegrita: "¿Deseás tomar el turno con tu obra social alternativa?",
        texto: "La determinacion seleccionada no figura dentro de tu cobertura",
        dissmiss: dissmiss,
      },
      [
        {
          text: "Cancelar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: cancelaAlternativa,
        },
        {
          text: "Tomar con OS alternativa",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: () => deterComoParticular("osAlternativa"),
        },
      ],
      "centro",
    )(modalDispatch);
  };

  const onHandleBuscarTurnosLabo = () => {
    setFiltraTurnos(true);
    hideSegundoModal()(segundoModalDispatch);
  };

  useEffect(() => {
    if (filtraTurnos) {
      onBuscarTurnosClick();
    }
  }, [filtraTurnos]);

  const showFiltrosLabo = () => {
    //saco el domingo ya que no entra dentro de los dias.
    showSegundoModal(
      "Turnos/FiltrosLabo/FiltrosLabo",
      {
        titulo: "Filtrar por centro",
        dissmiss: dissmissSegundoModal,
        onHandleBuscarTurnosLabo: onHandleBuscarTurnosLabo,
      },
      {},
      "centro",
    )(segundoModalDispatch);
  };

  const modalAtencionSinTurnoPrevio = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "El estudio se realiza sin turno previo",
        textoNegrita: "Prueba",
        texto: "a Definir",
        dissmiss: dissmiss,
        danger: true,
      },
      [
        {
          text: "Salir",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: dissmiss,
        },
        {
          text: "Leer sobre turnos sin reserva",
          clase: "btn-Mensaje-1 rb16m bgc-latex30 c-white",
          accion: dissmiss,
        },
      ],
      "centro",
    )(modalDispatch);
  };

  useEffect(() => {
    if (
      laboTurnosState.laboTurnos.data !== undefined &&
      laboTurnosState.laboTurnos.data !== null &&
      laboTurnosState.laboTurnos.data !== false &&
      laboTurnosState.laboTurnos.data !== ""
    ) {
      if (
        laboTurnosState.laboTurnos.data.continua &&
        laboTurnosState.laboTurnos.data.circuito === "OS"
      ) {
        setFlgModal(false);
        setFlgGrupoOk(true);
        logoutLaboTurnos()(laboTurnosDispatch);
      } else if (
        laboTurnosState.laboTurnos.data.data !== null &&
        laboTurnosState.laboTurnos.data.data !== undefined &&
        laboTurnosState.laboTurnos.data.data !== ""
      ) {
        // Mantener los filtros de centros tal como el usuario los configuró
        let centrosLabo =
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
            .centrosLabo;

        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: laboTurnosState.laboTurnos.data.data,
          grupoMedico: null,
          particular: flgParticular,
          idEstudio: idGrupo,
          descEstudio: descGrupo,
          descEspecialidad: null,
          fechaBusqueda: laboTurnosState.laboTurnos.data.fechaBusqueda,
          dtoBusqueda: dtoPOST,
          volverOrigen: "LABORATORIO",
          proceso: "labo",
          filtrosData: {
            ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
            centrosLabo,
          },
        })(turnosDisponiblesDispatch);
        setFlgParticular(true);
        hideModal()(modalDispatch);
        history.push("/turnosDisponibles");
      }
    } else if (
      laboTurnosState.laboTurnos.error !== null &&
      laboTurnosState.laboTurnos.error !== undefined &&
      laboTurnosState.laboTurnos.error !== false
    ) {
      if (laboTurnosState.laboTurnos.error.detail === "9") {
        setFlgParticular(true);
        setFlgModal(true);
        modalParticular();
        logoutLaboTurnos()(laboTurnosDispatch);
      } else if (laboTurnosState.laboTurnos.error.detail === "91") {
        setFlgModal(true);
        modalOSAlternativa();
        logoutLaboTurnos()(laboTurnosDispatch);
      } else if (laboTurnosState.laboTurnos.error.detail === "10") {
        modalAtencionSinTurnoPrevio();
        logoutLaboTurnos()(laboTurnosDispatch);
      } else {
        if (
          laboTurnosState.laboTurnos.error.detail !== "" &&
          laboTurnosState.laboTurnos.error.detail !== null &&
          laboTurnosState.laboTurnos.error.detail !== undefined
        ) {
          if (laboTurnosState.laboTurnos.error.detail.length > 100) {
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Atención",
                texto: (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: laboTurnosState.laboTurnos.error.detail,
                    }}
                  ></div>
                ),
                dissmiss: dissmiss,
                danger: true,
              },
              [
                {
                  text: "Volver",
                  clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                  accion: cancelaParticular,
                },
              ],
              "centro",
            )(modalDispatch);
            logoutLaboTurnos()(laboTurnosDispatch);
          } else {
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Información",
                texto: (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: laboTurnosState.laboTurnos.error.detail,
                    }}
                  ></div>
                ),
                dissmiss: dissmiss,
                danger: true,
              },
              [
                {
                  text: "Volver",
                  clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                  accion: cancelaParticular,
                },
              ],
              "centro",
              true,
            )(modalDispatch);
            logoutLaboTurnos()(laboTurnosDispatch);
          }
        } else {
          showToaster(
            {
              texto: (
                <div
                  dangerouslySetInnerHTML={{
                    __html: laboTurnosState.laboTurnos.error,
                  }}
                ></div>
              ),
              tipo: "danger",
            },
            "centroArriba",
          )(toasterDispatch);
          logoutLaboTurnos()(laboTurnosDispatch);
        }
      }
    }
  }, [laboTurnosState]);

  useEffect(() => {
    if (laboGrupoState.laboGrupo.data !== null) {
      setDeterminaciones(laboGrupoState.laboGrupo.data);
      setFecha(fechaTurnoFormat());
    }
    if (
      laboGrupoState.laboGrupo.centros !== null &&
      laboGrupoState.laboGrupo.centros !== undefined
    ) {
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .centrosLabo !== undefined
      ) {
        if (
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
            .centrosLabo.length === 1
        ) {
          let centrosLabo =
            turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
              .centrosLabo;
          let centro = [
            ...new Set(
              laboGrupoState.laboGrupo.centros.map((item) => item.descripcion),
            ),
          ];
          let ubicacion = [
            ...new Set(
              laboGrupoState.laboGrupo.centros.map((item) => item.ubicacion),
            ),
          ];
          let coordenadas = [
            ...new Set(
              laboGrupoState.laboGrupo.centros.map(
                (item) => item.coordenadaGps,
              ),
            ),
          ];
          const map = new Map();
          for (const item of centro) {
            for (const itemUbi of ubicacion) {
              for (const itemGps of coordenadas) {
                if (
                  !centrosLabo.filter(
                    (x) =>
                      x.descripcion === item &&
                      x.ubicacion === itemUbi &&
                      x.coordenadas === itemGps,
                  ).length > 0
                ) {
                  if (
                    !map.has(item) &&
                    !map.has(itemUbi) &&
                    !map.has(itemGps)
                  ) {
                    map.set(item);
                    map.set(itemUbi);
                    map.set(itemGps);
                    //para colocar correctamente los id. tomo el ultimo item de la lista. cuyo id + 1.
                    const lastItem = centrosLabo[centrosLabo.length - 1];
                    centrosLabo.push({
                      id: lastItem.id + 1,
                      descripcion: item,
                      ubicacion: itemUbi,
                      coordenadas: itemGps,
                      checked: true,
                    });
                  }
                }
              }
            }
          }
          // guardo los centros
          editaTurnosDisponibles({
            ...turnosDisponiblesState.turnosDisponibles.turnosData,
            filtrosData: {
              ...turnosDisponiblesState.turnosDisponibles.turnosData
                .filtrosData,
              centrosLabo: centrosLabo,
            },
          })(turnosDisponiblesDispatch);
        }
      }
    }
  }, []);

  //agrego logica volver a verificar estudio/consMed por cambio de paciente.
  useEffect(() => {
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      if (idGrupo !== "" && descGrupo !== "") {
        setFlgModal(false);
        setFlgParticular(false);
        setFlgGrupoOk(false);
        wsGetVerificarLaboGrupo(
          idGrupo,
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
        )(laboTurnosDispatch);
      }
    } else {
      if (idGrupo !== "" && descGrupo !== "") {
        setFlgModal(false);
        setFlgParticular(false);
        setFlgGrupoOk(false);
        wsGetVerificarLaboGrupo(idGrupo)(laboTurnosDispatch);
      }
    }
  }, [selectDropDownState.selectDropDown.selectGlobal]);

  // useEffect que hace que se elija general
  useEffect(() => {
    if (window.location.pathname === "/laboratorio" || buscadorTurnos) {
      onChangeBuscador({
        descripcion: "TURNO DE LABORATORIO GENERAL",
        id: 5,
        idusuario: "",
        idusuario_desc: null,
        orden: 1,
        reqcobroweb: false,
      });
    }
  }, []);

  useEffect(() => {
    if (
      determinaciones &&
      window.location.pathname === "/testpcr" &&
      idGrupo === ""
    ) {
      let objPCR = {
        descripcion: "PCR (HISOPADO)",
        id: 3,
        idusuario: "",
        idusuario_desc: null,
        orden: 2,
        reqcobroweb: false,
      };
      let arrx = [...determinaciones];
      arrx.push(objPCR);
      setDeterminaciones(arrx);
      onChangeBuscador(objPCR);
    }
  }, [determinaciones]);

  // Busca el dia de hoy para el datePicker
  const hoyDia = new Date();
  const noventaDiasDespues = new Date();
  noventaDiasDespues.setDate(noventaDiasDespues.getDate() + 90);

  const configDropdown = {
    data: determinaciones && determinaciones,
    header: "Seleccione el análisis a realizar",
    headerColor: buscadorTurnos && "c-white",
    footer: "",
    descripcion: "descripcion",
    placeholder:
      window.location.pathname !== "/laboratorio" ? "PCR (HISOPADO)" : "",
    placeHolderFontSize: 16,
    defaultValue:
      window.location.pathname === "/laboratorio" || buscadorTurnos
        ? "TURNO DE LABORATORIO GENERAL"
        : "PCR (HISOPADO)",
    defaultValueParametro: "descripcion",
    height: 38,
    cantidadItems: 10,
    maxlength: 100,
    error: null,
    arrow: true,
    search: false,
    disabled: false,
    tooltip: false,
    showUp: true,
    regex: /^[a-zA-Z\s]+$/,
  };

  return (
    <React.Fragment>
      {!buscadorTurnos && (
        <div className="ptur-buscadorLaboratorio-desktop-dropdown">
          <SelectDropdown
            data={dropdownFamiliares(
              listaFamiliaresState,
              authState,
              "ManejoTurnos",
            )}
            descripcion={"nombre"}
            placeholder={"Seleccionar Familiar"}
            onChangeInput={onChangeMultitabMobile}
            selectedValue={
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                ? selectDropDownState.selectDropDown.selectGlobal
                    .pacienteElegido.paciente
                : authState.auth.data.paciente
            }
            styles={{
              width: esMobile && "100%",
            }}
          />
        </div>
      )}

      <div
        className={
          buscadorTurnos
            ? "cuerpoPestaniaLaboratorioBuscadorTurno"
            : "cuerpoPestaniaLaboratorio"
        }
      >
        <div className="ptur-buscador-dropdown">
          <DropdownV2 config={configDropdown} onClick={onChangeBuscador} />
        </div>
        <div className="ptur-buscador-fecha-boton-laboratorio">
          <div className="ptur-buscador-fecha-laboratorio">
            <DatePicker
              fechaInicial={`${hoyDia.getFullYear()} ${
                hoyDia.getMonth() + 1
              } ${hoyDia.getDate()}`}
              fechaFinal={`${noventaDiasDespues.getFullYear()} ${
                noventaDiasDespues.getMonth() + 1
              } ${noventaDiasDespues.getDate()}`}
              headerStr={"Buscar fecha"}
              headerStrColor={buscadorTurnos && "c-white"}
              // fechaMin={hoy}
              // fechaMax={fechaLimte}
              onChange={onChangeDatePicker}
              customCss="ptur-datePicker-laboratorio"
            />
          </div>
          <div className="ptur-buscador-boton-laboratorio">
            <button
              onClick={onBuscarTurnosClick}
              className="ptur-btn-buscador-laboratorio bgc-primary c-white rb18m"
              disabled={laboTurnosState.laboTurnos.loading || deshabilitoBusq}
            >
              {laboTurnosState.laboTurnos.loading ? (
                <span className="ptur-buscadorEstudio-loading">
                  <IonSpinner name="lines-small" />
                </span>
              ) : (
                "Siguiente"
              )}
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BuscadorLaboratorio;
